import { useEffect, useMemo, useState } from "react";

import { t } from "i18next";

import AdvancedInput2 from "components/Custom/AdvancedInput2";
import { TYPE } from "../../constants";
import MDBox from "components/Basics/MDBox";
import { Divider } from "@mui/material";

const ThemeType = ({
	alternativeIndex,
	value,
	dictionary,
	setRightMenuPannel,
	language,
	languages,
	onChangePath,
	channelType
}) => {
	const [lastUpdate, setLastUpdate] = useState("");
	const [lastUpdateQuestion, setLastUpdateQuestion] = useState("");
	const [lastUpdateAnswer, setLastUpdateAnswer] = useState("");
	const [triggerMemo, setTriggerMemo] = useState(false);

	const getContent = () => {
		switch (channelType) {
			case TYPE.themeCategory: {
				return (
					<AdvancedInput2
						dictionary={dictionary}
						value={value?.text || ""}
						onChange={e => {
							setLastUpdate(prev => e);
							onChangePath("text", e);
						}}
						placeholder={t("COMPONENT.ANSWERTYPE.typeAnswer")}
						trigger={triggerMemo}
						multiline={false}
						onFocus={() => {
							setRightMenuPannel({
								open: true,
								alternative: alternativeIndex,
								language: language.code,
								languages,
								channelType
							});
						}}
					/>
				);
			}
			case TYPE.themeQuestion: {
				return (
					<MDBox>
						<AdvancedInput2
							dictionary={dictionary}
							value={value?.question || ""}
							onChange={e => {
								setLastUpdateQuestion(prev => e);
								onChangePath("question", e);
							}}
							placeholder="Tapez votre question ici ..."
							trigger={triggerMemo}
							onFocus={() => {
								setRightMenuPannel({
									open: true,
									alternative: alternativeIndex,
									language: language.code,
									languages,
									channelType
								});
							}}
						/>
						<Divider />
						<AdvancedInput2
							dictionary={dictionary}
							value={value?.answer || ""}
							onChange={e => {
								setLastUpdateAnswer(prev => e);
								onChangePath("answer", e);
							}}
							placeholder="Tapez votre réponse ici ..."
							trigger={triggerMemo}
							onFocus={() => {
								setRightMenuPannel({
									open: true,
									alternative: alternativeIndex,
									language: language.code,
									languages,
									channelType
								});
							}}
						/>
					</MDBox>
				);
			}
			default: {
				return null;
			}
		}
	};

	useEffect(() => {
		if (channelType === TYPE.themeCategory) {
			if (lastUpdate !== value?.text) {
				setTriggerMemo(prev => !prev);
			}
		} else if (channelType === TYPE.themeQuestion) {
			if (lastUpdateQuestion !== value?.question || lastUpdateAnswer !== value?.answer) {
				setTriggerMemo(prev => !prev);
			}
		}
	}, [value]);

	return (
		/**
		 * useMemo permet de rendre le composant uniquement lorsque triggerMemo change
		 * sinon, le composant serait re-rendu à chaque frappe de clavier
		 * ce qui causerait des problèmes de performance et des bugs visuels
		 */
		useMemo(() => {
			return getContent();
		}, [triggerMemo, channelType, alternativeIndex])
	);
};

export default ThemeType;
